import { useForm } from 'react-hook-form'
import { AuthData } from "../../pages/Authorization/AuthWrapper";
import { VscGear } from "react-icons/vsc";
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom'
import { logout } from '../../services/authorizationService';
import { showSuccess,showError } from '../../services/toastServices';
function UserSectionSidebar() {
    const { handleSubmit, formState: { errors } } = useForm();
    const { user,logoutRefresh } = AuthData();
    const navigate = useNavigate()

    const handleLogout = handleSubmit(async data => {   
        logout()
        showSuccess('Nos vemos pronto !!!')
        logoutRefresh()
        navigate('/login')
      })
    

    const renderloggedInUser = (() => {
        return (
            <div className="flex flex-col">
                <div className="basis-1/4 text-black text-left font-bold">{user.fullName}</div>
                <div className="text-slate-400">{user.email}</div>
                <div className=" text-right mt-2">
                    <a className="border-2 border-blue-400 text-blue-400 font-bold pb-1 pl-1 pr-1 rounded-lg block hover:bg-blue-500 hover:text-white text-center" onClick={handleLogout}>logout</a>
                </div>
            </div>
        )
    })

    const renderloggedOutUser = (() => {
        return (
            <div className="flex flex-col">
                <div className="text-black text-slate-400">Inicia sesión</div>
                <div className='flex flex-row'>
                    <div className="mt-2 mr-2">
                        <a 
                        href='/login'
                        className="border-2 border-blue-400 text-blue-400 font-bold pb-1 rounded-lg block hover:bg-blue-500 hover:text-white text-center px-4"
                        >login</a>
                    </div>
                    <div className="mt-2">
                        <a 
                        href='/signin'
                        className="border-2 border-blue-400 text-blue-400 font-bold pb-1 rounded-lg block hover:bg-blue-500 hover:text-white text-center px-4"
                        >Crear cuenta</a>
                    </div>
                </div>
                <div className="mt-1">
                        <a 
                        href='/reset-password-request'
                        className=" text-blue-400 pb-1 block hover:text-blue-500 text-center "
                        >¿Has olvidado la contraseña?</a>
                </div>


            </div>
        )
    })

    return (
        <div className="sticky top-0 overflow-auto scrollbar-hide flex flex-col items-start">
            {user.isAuthenticated ? renderloggedInUser() : renderloggedOutUser()}
        </div>
    )
};

export default UserSectionSidebar;